import API from "serviceshift-ui/api-client";

export default {
  async archiveComponentType(_, link) {
    await API.makeRequest(link, { method: "PUT" });
  },
  async createComponentType(_, data) {
    await API.makeRequest("/v2/component_types", { method: "POST", data });
  },
  async fetchComponentTypes({ commit }) {
    try {
      const res = await API.makeRequest("/v2/component_types", {
        method: "GET",
      });
      commit("replace", {
        state: "componentTypes",
        data: res.data,
      });
    } catch (e) {
      //no-op
    }
  },
  async unarchiveComponentType(_, link) {
    await API.makeRequest(link, { method: "PUT" });
  },
  async updateComponentType(_, { link, data }) {
    await API.makeRequest(link, { method: "PUT", data });
  },
};
